import React from 'react'

export default function TermsAndConditions() {
  return (
    <div>TermsAndConditions</div>
  )
}
